import { Badge } from "@/components/ui";
import type { DeploymentStatus } from "@/lib/types";

const DEPLOYMENT: Record<DeploymentStatus, [string, "success" | "info" | "danger" | "neutral"]> = {
  queued: ["Queued", "neutral"],
  building: ["Building", "info"],
  ready: ["Ready", "success"],
  failed: ["Failed", "danger"],
  unknown: ["Unknown", "neutral"],
};

export function DeploymentStatusBadge({ status }: { status: DeploymentStatus }) {
  const [label, tone] = DEPLOYMENT[status];
  return <Badge tone={tone}>{label}</Badge>;
}
